import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchAboutHighlights } from "../redux/actions/admin/aboutHighlightsAction";
import { Link } from "react-router-dom";
import CustomButton from "./CustomButton";

const SchoolAbout = () => {
  const dispatch = useDispatch();
  const { aboutHighlights } = useSelector((state) => state.aboutHighlights);

  const settings = {
    dots: true,
    infinite: aboutHighlights?.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  useEffect(() => {
    dispatch(fetchAboutHighlights());
  }, [dispatch]);

  return (
    <Box sx={{ backgroundColor: "#FFFFFF", pt: 5, pb: 5 }}>
      <Box sx={{ mr: { xs: 2, md: 8 }, ml: { xs: 2, md: 8 } }}>
        <Grid container spacing={4} alignItems="center">
          {/* Slider Section - Grid 6 */}
          <Grid item xs={12} md={6}>
            <Box sx={{ maxWidth: "100%", borderRadius: 5, overflow: "hidden" }}>
              <Slider {...settings}>
                {aboutHighlights?.map((image, index) => (
                  <Box
                    key={index}
                    sx={{ height: { xs: 300, md: 450 }, overflow: "hidden" }}
                  >
                    <img
                      src={image.imageUrl}
                      alt={`Slide ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        // objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
              </Slider>
            </Box>
          </Grid>
          {/* About Us Section - Grid 6 */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: "Poppins, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
                letterSpacing: 1,
                color: "#065A79",
                fontWeight: "bold",
                p: 1,
              }}
              gutterBottom
            >
              About Us
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
                letterSpacing: 1,
                color: "#AD1C86",
                fontWeight: "bold",
              }}
              gutterBottom
            >
              Welcome to Shree Mangalam School
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
                letterSpacing: 1,
                lineHeight: "1.8rem",
                fontSize: 15,
              }}
            >
              {/* Located on Udaipurwati Road, Gudha, in the heart of District Jhunjhunu, Shree Mangalam School is the newest name in educational excellence. */}
              Located on Jaipur-Gudha State Highway (Just on by pass) in Gudha Gorji, Shree Mangalam School is the branded name in educational excellence. Our school is dedicated to providing high-quality education that blends traditional values with modern learning methods, ensuring that every student receives the attention, guidance, and opportunities they deserve.
              At Shree Mangalam School, education is a shared journey involving students, parents, teachers, and staff. We foster a culture of collaboration and mutual respect where everyone feels valued and heard. Our goal is to create a nurturing environment that inspires growth, celebrates success, and supports each student’s unique potential.
              As we embark on this journey of transformation and excellence, we invite you to be a part of the Shree Mangalam School family. Whether you're a student seeking quality education or a parent looking for a school that truly cares, you'll find a home here. Together, let’s build a brighter future — one student at a time.
            </Typography>

            <Link to="/about-school" style={{ textDecoration: "none" }}>
              <CustomButton ButtonName={"More About Us"} />
            </Link>
          </Grid>

          
        </Grid>
      </Box>
    </Box>
  );
};

export default SchoolAbout;
